import { render, staticRenderFns } from "./AttachmentListItem.vue?vue&type=template&id=471893fa&scoped=true"
import script from "./AttachmentListItem.vue?vue&type=script&lang=ts"
export * from "./AttachmentListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471893fa",
  null
  
)

export default component.exports